export default __webpack_public_path__ + "static/media/icaew_s3.31d54f5d.png";